import { Layer, View } from "@hscmap/stellar-globe"
import { LayerComponentBase } from '@/stellar-globe-components'
import { Component, Prop, Watch } from "vue-property-decorator"
import { AreaRenderer, Filter } from "./AreaRenderer"
import { MixerType, SspDataModule } from '..'
import { FrameStore } from '@/modules/base'
import { V3 } from '@/utils/math'

class SspAreaLayer extends Layer {
  constructor(public url: string, private frameStore: FrameStore<typeof SspDataModule>) {
    super()
    this.refresh()
  }

  fr!: AreaRenderer
  onAdd() {
    this.fr = new AreaRenderer(this.globe, this.url, this.filters())
  }

  onRemove() {
    this.fr.release()
  }

  render(view: View) {
    this.fr.alpha = Layer.overlayAlpha(view)
    this.fr.render(view)
  }

  refresh() {
    this.globe && this.fr.setFilter(this.filters())
  }

  private filters(): Filter[] {
    const params = this.frameStore.params
    if (params.type == MixerType.SIMPLE_COLOR_MATRIX) {
      return params.simpleColorMatrix.colors.map(c => ({
        filterName: c.filterName,
        color: c.value,
      }))
    } else {
      return params.filter.map((f, i) => ({
        filterName: f,
        color: ([[1, 0, 0], [0, 1, 0], [0, 0, 1]] as V3[])[i],
      }))
    }
  }
}

@Component
export default class SspAreaLayerComponent extends LayerComponentBase<SspAreaLayer> {
  @Prop({ required: true })
  url!: string

  @Prop({ required: true })
  frameStore!: FrameStore<typeof SspDataModule>

  mounted() {
    this.$watch(() => [
      this.frameStore.params.type,
      this.frameStore.params.filter,
      this.frameStore.params.simpleColorMatrix.colors,
    ], () => {
      console.log('refresh!')
      this.layer.refresh()
    }, { deep: true })
  }

  newLayer() {
    return new SspAreaLayer(this.url, this.frameStore)
  }
}
